
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { smoothScrollToTop } from "../../lib/utils";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small timeout to ensure render has started
    const timer = setTimeout(() => {
      smoothScrollToTop(500);
    }, 50);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
